import React from 'react';
import { trimTitle } from '../../utils';
import styles from './DeviceChartTitle.module.css';

// @todo remove config
function DeviceChartTitle({ title, config }) {
  return <div className={styles.root}>{trimTitle(title ?? config.title)}</div>;
}

export default DeviceChartTitle;
